module.exports = __webpack_public_path__ + "pstatic/img/report5.715d7e11.png";